// Generated file. Do not edit
export const statusCodeToReasonPhrase: Record<string, string> = {
  100: 'Continue',
  101: 'Switching Protocols',
  102: 'Processing',
  103: 'Early Hints',
  200: 'OK',
  201: 'Created',
  202: 'Accepted',
  203: 'Non Authoritative Information',
  204: 'No Content',
  205: 'Reset Content',
  206: 'Partial Content',
  207: 'Multi-Status',
  300: 'Multiple Choices',
  301: 'Moved Permanently',
  302: 'Moved Temporarily',
  303: 'See Other',
  304: 'Not Modified',
  305: 'Use Proxy',
  307: 'Temporary Redirect',
  308: 'Permanent Redirect',
  400: 'Bad Request',
  401: 'Unauthorized',
  402: 'Payment Required',
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method Not Allowed',
  406: 'Not Acceptable',
  407: 'Proxy Authentication Required',
  408: 'Request Timeout',
  409: 'Conflict',
  410: 'Gone',
  411: 'Length Required',
  412: 'Precondition Failed',
  413: 'Request Entity Too Large',
  414: 'Request-URI Too Long',
  415: 'Unsupported Media Type',
  416: 'Requested Range Not Satisfiable',
  417: 'Expectation Failed',
  418: "I'm a teapot",
  419: 'Insufficient Space on Resource',
  420: 'Method Failure',
  421: 'Misdirected Request',
  422: 'Unprocessable Entity',
  423: 'Locked',
  424: 'Failed Dependency',
  426: 'Upgrade Required',
  428: 'Precondition Required',
  429: 'Too Many Requests',
  431: 'Request Header Fields Too Large',
  451: 'Unavailable For Legal Reasons',
  500: 'Internal Server Error',
  501: 'Not Implemented',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout',
  505: 'HTTP Version Not Supported',
  507: 'Insufficient Storage',
  511: 'Network Authentication Required',
}
export const reasonPhraseToStatusCode: Record<string, number> = {
  Accepted: 202,
  'Bad Gateway': 502,
  'Bad Request': 400,
  Conflict: 409,
  Continue: 100,
  Created: 201,
  'Early Hints': 103,
  'Expectation Failed': 417,
  'Failed Dependency': 424,
  Forbidden: 403,
  'Gateway Timeout': 504,
  Gone: 410,
  'HTTP Version Not Supported': 505,
  "I'm a teapot": 418,
  'Insufficient Space on Resource': 419,
  'Insufficient Storage': 507,
  'Internal Server Error': 500,
  'Length Required': 411,
  Locked: 423,
  'Method Failure': 420,
  'Method Not Allowed': 405,
  'Misdirected Request': 421,
  'Moved Permanently': 301,
  'Moved Temporarily': 302,
  'Multi-Status': 207,
  'Multiple Choices': 300,
  'Network Authentication Required': 511,
  'No Content': 204,
  'Non Authoritative Information': 203,
  'Not Acceptable': 406,
  'Not Found': 404,
  'Not Implemented': 501,
  'Not Modified': 304,
  OK: 200,
  'Partial Content': 206,
  'Payment Required': 402,
  'Permanent Redirect': 308,
  'Precondition Failed': 412,
  'Precondition Required': 428,
  Processing: 102,
  'Proxy Authentication Required': 407,
  'Request Entity Too Large': 413,
  'Request Header Fields Too Large': 431,
  'Request Timeout': 408,
  'Request-URI Too Long': 414,
  'Requested Range Not Satisfiable': 416,
  'Reset Content': 205,
  'See Other': 303,
  'Service Unavailable': 503,
  'Switching Protocols': 101,
  'Temporary Redirect': 307,
  'Too Many Requests': 429,
  Unauthorized: 401,
  'Unavailable For Legal Reasons': 451,
  'Unprocessable Entity': 422,
  'Unsupported Media Type': 415,
  'Upgrade Required': 426,
  'Use Proxy': 305,
}
